import React from "react";
import { Outlet, Navigate } from "react-router-dom";

import App from "./../app.jsx";

import auth from "./../services/authservice";

import DashboardV3 from "./../pages/dashboard/dashboard-v3.js";
import DashboardV2 from "./../pages/dashboard/dashboard-v2.js";
import DashboardV1 from "./../pages/dashboard/dashboard-v1.js";

import ExtraTimeline from "./../pages/extra/extra-timeline.js";
import ExtraComingSoon from "./../pages/extra/extra-coming-soon.js";
import ExtraSearch from "./../pages/extra/extra-search.js";
import ExtraInvoice from "./../pages/extra/extra-invoice.js";
import ExtraError from "./../pages/extra/extra-error.js";
import ExtraProfile from "./../pages/extra/extra-profile.js";
import ExtraScrumBoard from "./../pages/extra/extra-scrum-board.js";
import ExtraCookieAcceptanceBanner from "./../pages/extra/extra-cookie-acceptance-banner.js";
import ExtraOrders from "./../pages/extra/extra-orders.js";
import ExtraOrderDetails from "./../pages/extra/extra-order-details.js";
import ExtraProducts from "./../pages/extra/extra-products.js";
import ExtraProductDetails from "./../pages/extra/extra-product-details.js";

import LoginV2 from "./../pages/user/login.js";
import RegisterV3 from "./../pages/user/register-v3.js";
import Logout from "./../common/logout";

//////////////////////////////////////////////////////////////////////////////////////////////
import User from "./../pages/user/user";
import UserTable from "./../pages/user/users.js";
import GridTicket from "./../pages/ticket/gridtickets.js";
import Ticket from "./../pages/ticket/ticket.js";
import TicketCategory from "./../pages/ticket/ticketcategory.js";
import TicketCategoryTable from "./../pages/ticket/ticketcategories.js";
import TicketTable from "./../pages/ticket/tickets.js";
import TicketProfile from "./../pages/ticket/ticketprofile";
import Company from "./../pages/crm/company.js";
import CompanyTable from "./../pages/crm/companies.js";
import ScrumMaster from "./../pages/user/scrummaster.js";
import ScrumMasterTable from "./../pages/user/scrummasters.js";
import Supervisor from "./../pages/user/supervisor.js";
import SupervisorTable from "./../pages/user/supervisors.js";
import Operator from "./../pages/user/operator.js";
import OperatorTable from "./../pages/user/operators.js";
import Accountant from "./../pages/user/accountant.js";
import AccountantTable from "./../pages/user/accountants.js";
import Reception from "./../pages/user/reception.js";
import ReceptionTable from "./../pages/user/receptions.js";
import Label from "./../pages/label/label.js";
import LabelsTable from "./../pages/label/labels.js";
import LabelPrint from "./../pages/label/labelPrint.js";
import LabelDesign from "../pages/label/LabelDesign/LabelDesign.js";
import COOItems from "./../pages/ERP/COOItems.js";
import COOitemXLS from "./../pages/ERP/COOitemXLS.jsx";
import COOItem from "./../pages/ERP/COOItem.js";
import RVS from "./../pages/ERP/RVS.js";
import RVSs from "./../pages/ERP/RVSs.js";
import RLC from "./../pages/workinstructions/RLC.js";
import OutboundGDC from "./../pages/workinstructions/OutboundGDC.js";
import OTM from "./../pages/workinstructions/OTM.js";
import VL09 from "./../pages/workinstructions/VL09.js";
import Shipment from "./../pages/workinstructions/Shipment.js";

import Confirmationdeliveries from "./../pages/workinstructions/Confirmationdeliveries.js";

import Printerconfiguration from "./../pages/workinstructions/Printerconfiguration.js";
import Password from "./../pages/workinstructions/Password.js";
import RLCGoodsReceive from "./../pages/workinstructions/RLCGoodsReceive.js";
import ALUInbound from "./../pages/workinstructions/ALUInbound.js";
import ALUOutbound from "./../pages/workinstructions/ALUOutbound.js";
import ALUOutboundCheatSheet from "./../pages/workinstructions/ALUOutboundCheatSheet.js";
import ALUOutboundCheatSheet2 from "./../pages/workinstructions/ALUOutboundCheatSheet2.js";
import Workinstruction from "./../pages/workinstructions/workinstruction.js";
import WorkInstructionsTable from "./../pages/workinstructions/workinstructions.js";
import WorkInstructionBoard from "./../pages/workinstructions/WorkInstructionBoard.jsx";
import ERInstruction from "./../pages/erinstructions/erinstruction.js";
import ERInstructionsTable from "./../pages/erinstructions/erinstructions.js";
import ERInstructionBoard from "./../pages/erinstructions/ERInstructionBoard.jsx";
import CapaFormISO from "./../pages/QESH/CAPAFormISO.js";

// import ImageAnnotation from "./../pages/AIML/ImageAnnotation.js";
// import ImageAnnotations from "../pages/AIML/ImageAnnotations.js";
//import imageannotation from "./../pages/AIML/imageannotation.js";
//import imageannotations from "../pages/AIML/imageannotations.js";
//import Freelancer from "./../pages/user/freelancer.js";
//import FreelancerTable from "./../pages/user/freelancers.js";

//  import BarcodeScanner from "./../pages/barcodescanner.js";
import Places from "./../pages/map/places.js";

//import Appointment from '../pages/beautysalon/appointment.js';
//import AppointmentTable from '../pages/beautysalon/appointments.js';
import Calendar from "../pages/calendar/calendar.js";

//import Scheduler from "../pages/calendar/scheduler"

//Forums
import PostsOfTopic from "./../pages/forum/TopicDetail.js";
// import ForumBody from "./../pages/forum/postdetail.js";
// import PostForTopic from "./../pages/forum/postForTopic.js";
import ForumHome from "./../pages/forum/ForumHome.js";
import Forum from "./../pages/forum/Forums";
// import ForumBodyTopic from "./../pages/forum/topicDetails.js";
///////////////////////////////////////////

import YourDrive from "../pages/drive/yourdrive";

import UserRoleTableData from "./../pages/user/userroles";
import PermissionTab from "./../pages/user/permissions.js";
import UserRole from "./../pages/user/userrole.js";
import Profile from "./../pages/user/profile/profile";
import ModulePermission from "./../pages/user/modulepermission";
import ModulePermissionTable from "./../pages/user/modulepermissions";
import ForumCategoriesTableData from "../pages/forum/forumcategories/forumcategories.js";
import Forumcategory from "../pages/forum/forumcategories/forumcategory.js";
import OuterboxBarcodeTable from "../pages/ERP/outerboxbarcodeimages.jsx";

function RequireAuth({ children }) {
  const isAuthenticated = auth.getProfile() !== null;

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

const Home = () => {
  const isAuthenticated = auth.getProfile() != null;
  return isAuthenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

const AppRoute = [
  {
    path: "",
    element: <Home />,
  },
  {
    path: "*",
    element: <App />,
    children: [
      {
        //path: 'login/*',
        path: "login/",
        element: <LoginV2 />,
        // children: [
        // 	{ path: 'login-v1', element:<LoginV1 /> },
        // 	{ path: 'user', element:<LoginV2 /> },
        // 	// { path: 'login-v3', element:<LoginV3 /> },
        // 	// { path: 'register-v3', element:<RegisterV3 /> }
        // ]
      },
      {
        path: "",
        // element: auth.getProfile() == true ? ( <DashboardV1 />): (
        // 	<Navigate to={"/login"} replace></Navigate>
        // )
        //element:<Navigate to={"/login"} replace></Navigate>
        element: (
          <RequireAuth>
            <DashboardV1 />
          </RequireAuth>
        ),
      },
      {
        path: "*",
        element: <ExtraError />,
      },
      {
        path: "dashboard/*",
        //element: <Outlet />,
        // element: auth.getProfile() ? ( <DashboardV1 />): (
        // 	<Navigate to={"/login"} replace></Navigate>
        // )
        element: (
          <RequireAuth>
            <DashboardV1 />
          </RequireAuth>
        ),
        children: [
          { path: "v1", element: <DashboardV1 /> },
          { path: "v2", element: <DashboardV2 /> },
          // 	{ path: 'v3', element: auth.getProfile() ? ( <DashboardV1 />): (
          // 		<Navigate to={"/login"} replace></Navigate>
          // 	) }
        ],
      },
      //   {
      // 			path: 'scheduler/*',
      // 			element: <Scheduler />
      // 		},
      {
        path: "logout",
        element: <Logout />,
      },

      // {
      // 	path: 'user/*',
      // 	element: <Outlet />,
      // 	children: [
      // 		{ path: 'users/:id', element:<User /> },
      // 		{ path: 'users/', element:<UserTable /> },
      // 		{ path: 'scrummasters/:id', element:<ScrumMaster /> },
      // 		{ path: 'scrummasters/', element:<ScrumMasterTable /> },
      // 		{ path: 'supervisors/:id', element:<Supervisor /> },
      // 		{ path: 'supervisors/', element:<SupervisorTable /> },
      // 	]
      // },

      {
        path: "user/*",
        element: <Outlet />,
        children: [
          { path: "profile", element: <Profile /> },
          { path: "users/:id", element: <User /> },
          { path: "users/", element: <UserTable /> },
          // { path: 'clients/:id', element:<Client /> },
          // { path: 'clients/', element:<ClientTable /> },
          //{ path: "freelancers/:id", element: <Freelancer /> },
          //          { path: "freelancers/", element: <FreelancerTable /> },
          { path: "accountants/:id", element: <Accountant /> },
          { path: "accountants/", element: <AccountantTable /> },
          { path: "receptions/:id", element: <Reception /> },
          { path: "receptions/", element: <ReceptionTable /> },
          { path: "scrummasters/:id", element: <ScrumMaster /> },
          { path: "scrummasters/", element: <ScrumMasterTable /> },
          { path: "supervisors/:id", element: <Supervisor /> },
          { path: "supervisors/", element: <SupervisorTable /> },
          { path: "operators/:id", element: <Operator /> },
          { path: "operators/", element: <OperatorTable /> },
          { path: "userroles/", element: <UserRoleTableData /> },
          { path: "permissions/:id", element: <UserRole /> },
          { path: "permissions/", element: <PermissionTab /> },
          { path: "userroles/", element: <UserRoleTableData /> },
          { path: "modulepermissions/:id", element: <ModulePermission /> },
          { path: "modulepermissions/", element: <ModulePermissionTable /> },

          //{ path: 'workinghours', element:<WorkingHours /> },
        ],
      },
      {
        path: "ticket/*",
        element: <Outlet />,
        children: [
          { path: "tickets/:id", element: <Ticket /> },
          { path: "ticketcategories/:id", element: <TicketCategory /> },
          { path: "ticketcategories/", element: <TicketCategoryTable /> },
          { path: "tickets/", element: <TicketTable /> },
          { path: "ticketprofile/:id", element: <TicketProfile /> },
          { path: "calendar", element: <Calendar /> },
          { path: "gridtickets", element: <GridTicket /> },
        ],
      },

      {
        path: "forum/*",
        element: <Outlet />,
        children: [
          { path: "forums/:forum_id", element: <Forum /> },
          { path: "forums/", element: <ForumHome /> },
          { path: "topic/:topicId", element: <PostsOfTopic /> },
          { path: "forumcategories/:id", element: <Forumcategory /> },
          { path: "forumcategories", element: <ForumCategoriesTableData /> },
        ],
      },
      {
        path: "workinstructions/*",
        element: <Outlet />,
        children: [
          { path: "RLCGoodsReceive", element: <RLCGoodsReceive /> },
          { path: "RLC", element: <RLC /> }, 
          { path: "OutboundGDC", element: <OutboundGDC /> },  
          { path: "OTM", element: <OTM /> },
          { path: "VL09", element: <VL09 /> },
          { path: "Shipment", element: <Shipment /> },
          { path: "Password", element: <Password /> },
          { path: "Confirmationdeliveries", element: <Confirmationdeliveries /> },
          { path: "Printerconfiguration", element: <Printerconfiguration /> },
          { path: "ALUInbound", element: <ALUInbound /> },
          { path: "ALUOutbound", element: <ALUOutbound /> },
          { path: "ALUOutboundCheatSheet", element: <ALUOutboundCheatSheet /> },
          {
            path: "ALUOutboundCheatSheet2",
            element: <ALUOutboundCheatSheet2 />,
          },
          {
            path: "workinstructions/:id",
            element: (
              <RequireAuth>
                <Workinstruction />
              </RequireAuth>
            ),
          },
          {
            path: "workinstructions/board/:id",
            element: (
              <RequireAuth>
                <WorkInstructionBoard />
              </RequireAuth>
            ),
          },
          {
            path: "workinstructions/",
            element: (
              <RequireAuth>
                <WorkInstructionsTable />
              </RequireAuth>
            ),
          },
          {
            path: "erinstructions/:id",
            element: (
              <RequireAuth>
                <ERInstruction />
              </RequireAuth>
            ),
          },
          {
            path: "erinstructions/new",
            element: (
              <RequireAuth>
                <ERInstruction />
              </RequireAuth>
            ),
          },
          {
            path: "erinstructions/board/:id",
            element: (
              <RequireAuth>
                <ERInstructionBoard />
              </RequireAuth>
            ),
          },
          {
            path: "erinstructions/",
            element: (
              <RequireAuth>
                <ERInstructionsTable />
              </RequireAuth>
            ),
          },
          {
            path: ":id",
            element: (
              <RequireAuth>
                <Workinstruction />
              </RequireAuth>
            ),
          },
        ],
      },
      {
        path: "QESH/*",
        element: <Outlet />,
        children: [
          //{ path: "QESH", element: <QESH /> },
        ],
      },

      {
        path: "map/*",
        element: <Outlet />,
        children: [{ path: "places", element: <Places /> }],
      },

      {
        path: "label/*",
        element: <Outlet />,
        children: [
          { path: "labels/:id", element: <Label /> },
          { path: "labels/", element: <LabelsTable /> },
          { path: "labelprint/", element: <LabelPrint /> },
          { path: "labeldesign/", element: <LabelDesign /> },
          //{ path: "barcode", element: <BarcodeScanner /> },
        ],
      },
      {
        path: "ERP/*",
        element: <Outlet />,
        children: [
          { path: "cooitems/:id", element: <COOItem /> },
          { path: "cooitems/", element: <COOItems /> },
          { path: "COOitemsxls/", element: <COOitemXLS /> },
          { path: "rvss/:id", element: <RVS /> },
          { path: "rvss/", element: <RVSs /> },
          { path: "outerboxbarcodeimages/", element: <OuterboxBarcodeTable /> },
        ],
      },
      {
        path: "AIML/*",
        element: <Outlet />,
        children: [
          //   { path: "ImageAnnotations/:id", element: <ImageAnnotation /> },
          //   { path: "ImageAnnotations/", element: <ImageAnnotations /> },
          // { path: "imageannotations/:id", element: <ImageAnnotation /> },
          // { path: "imageannotations/", element: <ImageAnnotations /> },
        ],
      },

      {
        path: "crm/*",
        element: <Outlet />,
        children: [
          { path: "companies/:id", element: <Company /> },
          { path: "companies/", element: <CompanyTable /> },
        ],
      },

      {
        path: "yourdrive/*",
        element: <YourDrive />,
      },

      // {
      //   path: "forum*",
      //   element: <Outlet />,
      //   children: [
      //     { path: "topics/:id", element: <PostsOfTopic /> },
      //     { path: "/:id", element: <TopicsOfCategory /> },
      //     { path: "/topic/newPost/:topicId" , element: <postForTopic />},
      //     { path: "/" , element: <Forum />}
      //   ],
      // },

      {
        path: "extra/*",
        element: <Outlet />,
        children: [
          { path: "timeline", element: <ExtraTimeline /> },
          { path: "coming-soon", element: <ExtraComingSoon /> },
          { path: "search", element: <ExtraSearch /> },
          { path: "invoice", element: <ExtraInvoice /> },
          { path: "error", element: <ExtraError /> },
          { path: "profile", element: <ExtraProfile /> },
          { path: "scrum-board", element: <ExtraScrumBoard /> },
          {
            path: "cookie-acceptance-banner",
            element: <ExtraCookieAcceptanceBanner />,
          },
          { path: "orders", element: <ExtraOrders /> },
          { path: "order-details", element: <ExtraOrderDetails /> },
          { path: "products", element: <ExtraProducts /> },
          { path: "product-details", element: <ExtraProductDetails /> },
        ],
      },
    ],
  },
];

export default AppRoute;
